import { getPet } from 'src/game/pet';
import { TutorialHandService } from './TutorialHandService';
import { TutorialOverlayService } from './TutorialOverlayService';
import { TutorialHandServiceAlt } from './TutorialHandServiceAlt';
import { TutorialHighlightService } from './TutorialHighlightService';

export type TutorialServices = ReturnType<typeof getTutorialServices>;

export function getTutorialServices() {
  return {
    hand: new TutorialHandService(),
    pet: () => getPet(),
    overlay: new TutorialOverlayService(),
    // Custom tutorial hand service, for the tutorial v2 test
    handAlt: new TutorialHandServiceAlt(),
    // Highlight specific views with optional pointers and arrows
    highlight: new TutorialHighlightService(),
  };
}
